<template>
<div class="research_group_container">
  <div class="hd_fixed">
    <div class="hd">
      <span class="icon icon-left navshare" @click="goBack" v-if="!isWapp"></span>
      <span class="header_title">G客中心</span>
    </div>
    <svg class="actionBg" width="100vw" height="27.73vw" viewBox="0 0 375 104" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
      <!-- Generator: Sketch 63.1 (92452) - https://sketch.com -->
      <title>形状结合@3x</title>
      <desc>Created with Sketch.</desc>
      <g id="页面-1" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
        <g id="G客中心" transform="translate(0.000000, -51.000000)" fill="#2C2C2C">
          <path d="M0,51 L375,51 L375,138 L372.172635,138.511249 C310.911081,149.50375 249.520202,155 188,155 C125.533333,155 62.8666666,149.333333 0,138 L0,138 L0,51 Z" id="形状结合"></path>
        </g>
      </g>
    </svg>

    <van-swipe @change="changeVip" v-if="displayChosenResearchGroup">
      <van-swipe-item v-for="item in 5" :key="item">
        <div class="current_group">{{ displayChosenResearchGroup.researchGroupName }}</div>
        <svg class="current_status" v-if="item=== displayChosenResearchGroup.vipLevel" width="71px" height="18px" viewBox="0 0 71 18" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
          <!-- Generator: Sketch 63.1 (92452) - https://sketch.com -->
          <title>课题组组长标签</title>
          <desc>Created with Sketch.</desc>
          <defs>
            <linearGradient x1="100%" y1="50%" x2="0%" y2="50%" id="linearGradient-1">
              <stop stop-color="#F0CFA6" offset="0%"></stop>
              <stop stop-color="#C1864A" offset="100%"></stop>
            </linearGradient>
          </defs>
          <g id="页面-1" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
            <g id="G客中心" transform="translate(-254.000000, -104.000000)">
              <g id="编组" transform="translate(25.000000, 61.000000)">
                <g id="课题组组长标签" transform="translate(229.000000, 43.000000)">
                  <rect id="矩形" fill="url(#linearGradient-1)" x="0" y="0" width="71" height="18" rx="9"></rect>
                  <text id="当前等级" font-family="PingFangSC-Regular, PingFang SC" font-size="12" font-weight="normal" fill="#FFFFFF">
                    <tspan x="11" y="13">当前等级</tspan>
                  </text>
                </g>
              </g>
            </g>
          </g>
        </svg>
        <img :src="vipImg(item)" style="width:100%;"/>
      </van-swipe-item>
    </van-swipe>
  </div>

  <div class="box_2">
    <object class="benefit_svg" :data="vipBenefitSvg" type="image/svg+xml"/>
  </div>
</div>
</template>

<script>
import {mapGetters} from 'vuex'
export default {
  data () {
    return {
      currentIndex: 0
    }
  },
  computed: {
    ...mapGetters([
      'hasLogin', 'customerNo', 'displayChosenResearchGroup', 'isWapp'
    ]),
    vipBenefitSvg () {
      let index = this.currentIndex + 1
      return `static/img/svg/VIP${index}权益.svg`
    }
  },
  methods: {
    goBack () {
      this.$router.go(-1)
    },
    vipImg (item) {
      return `static/img/VIP${item}.png`
    },
    changeVip (newVal, oldVal) {
      console.log('val', newVal, oldVal)
      this.currentIndex = newVal
    }
  }
}
</script>

<style scoped>
  .research_group_container {
    overflow-y:auto;
    overflow-x:hidden;
    /*-webkit-overflow-scrolling:touch;*/
    height:100%;
  }

  .hd_fixed {
    /*display: flex;*/
    position: fixed;
    top:0;
    left:0;
    /*align-items: center;*/
    /*flex-direction: column;*/
    /*background-color: #2c2c2c;*/
    width: 100vw;
    height: 40%;
    z-index: 10;
    /*justify-content: flex-start;*/
  }
  .hd {
    display: flex;
    /*position: fixed;*/
    /*top:0;*/
    /*left:0;*/
    align-items: center;
    flex-direction: row;
    background-color: #2c2c2c;
    width: 100vw;
    height: 14.93vw;
    z-index: 10;
    justify-content: center;
  }
  .icon-left:before {
    content: "\e614";
    color: #e6c3a0;
  }

  .navshare {
    position: absolute;
    left: 6.67vw;
    width: 10vw;
    height: 10vw;
    padding-top: 2vw;
    color:#ffffff;
  }
  .header_title {
    opacity: 1;
    /*margin-left: 29.33vw;*/
    max-width: 60.53vw;
    height: 5.87vw;
    overflow: hidden;
    text-overflow: ellipsis;
    line-height: 5.87vw;
    white-space: nowrap;
    color: #ffffff;
    font-size: 4.27vw;
    font-weight: 400;
    color: #e6c3a0;
  }
  .current_status {
    position: absolute;
    right: 9vw;
    top: 15vw;
  }
  .current_group {
    position: absolute;
    left: 9vw;
    top: 15vw;
    font-size: 4vw;
    color: #ffffff;
  }

  .box_2 {
    /*display: flex;*/
    position: absolute;
    /*align-items: center;*/
    /*flex-direction: column;*/
    background-color: #efeef3;
    width: 100vw;
    height: calc(100vh - 70vw);
    top: 70vw;
    overflow-y: auto;
  }
  .benefit_svg {
    width: 100%;
    margin-bottom: 10vw;
    padding: 0 7vw;
  }
  .actionBg {
    position: absolute;
    top: 13.6vw;
    align-self: center;
    width: 100vw;
    height: 27.73vw;
  }

  .el-carousel__item h3 {
    color: #475669;
    font-size: 14px;
    opacity: 0.75;
    line-height: 20px;
    margin: 0;
    position: absolute;
    right: 5px;
    top: 5px;
    /*height: 20px;*/
  }

  /*.el-carousel__item:nth-child(2n) {*/
    /*background-color: #99a9bf;*/
  /*}*/

  /*.el-carousel__item:nth-child(2n+1) {*/
    /*background-color: #d3dce6;*/
  /*}*/

</style>



// WEBPACK FOOTER //
// Benefit.vue?95f90a62